import DsCookies from './DsCookies';
import CookiesInfoBox from './InfoBox.vue';
const DsCookiesPlugin = {
    install(app, options) {
        let cookies = new DsCookies(options);
        app.provide('cookies', cookies);
        app.component('CookiesInfoBox', CookiesInfoBox);
    }
};
export default DsCookiesPlugin;
